/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DifferedReminderDateSubmitModel } from '../models/DifferedReminderDateSubmitModel';
import type { DifferedReminderModel } from '../models/DifferedReminderModel';
import type { DifferedRemindersLogModelPagedListData } from '../models/DifferedRemindersLogModelPagedListData';
import type { DifferedRemindersStatusEnum } from '../models/DifferedRemindersStatusEnum';
import type { DifferedReminderStatusSubmitModel } from '../models/DifferedReminderStatusSubmitModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DifferedRemindersService {

  /**
   * Get differed quotes table data
   * @param dateFrom 
   * @param dateTo 
   * @param status
 *
 * 0 = Active
 *
 * 1 = Booked
 *
 * 2 = Closed
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns DifferedRemindersLogModelPagedListData Success
   * @throws ApiError
   */
  public static getDifferedReminders(
dateFrom: string,
dateTo: string,
status?: DifferedRemindersStatusEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<DifferedRemindersLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/differed-reminders',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'Status': status,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Get wip info and all differed quotes by soHeaderId
   * @param id 
   * @returns DifferedReminderModel Success
   * @throws ApiError
   */
  public static getDifferedReminders1(
id: number,
): CancelablePromise<DifferedReminderModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/differed-reminders/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Set reminder status to quotes
   * @param requestBody List of quotes id with new remider statuses
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDifferedRemindersReminderStatus(
requestBody?: Array<DifferedReminderStatusSubmitModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/differed-reminders/reminder-status',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Set reminder date to quotes
   * @param requestBody List of quotes id with new remider date
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDifferedRemindersReminderDate(
requestBody?: Array<DifferedReminderDateSubmitModel>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/differed-reminders/reminder-date',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
